import { Button, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';

const { Paragraph } = Typography;

export default function TimetableHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const cards = [
    {
      path: '/education/timetable/smart',
      title: t('smartTimetableStudio', { defaultValue: 'Smart Timetable Studio' }),
      desc: t('smartTimetableStudioIntro', {
        defaultValue: 'AI-assisted generation, scenario compare, and governed publish into existing grids.',
      }),
    },
    { path: '/education/timetable/periods', title: t('timetablePeriods'), desc: t('timetablePeriodsIntro') },
    { path: '/education/timetable/rooms', title: t('timetableRooms'), desc: t('timetableRoomsIntro') },
    { path: '/education/timetable/grids', title: t('timetableGrids'), desc: t('timetableGridsIntro') },
    { path: '/education/timetable/teacher', title: t('timetableTeacherView'), desc: t('timetableTeacherViewIntro') },
    { path: '/education/substitutions', title: t('substitutions'), desc: t('substitutionsIntro') },
  ];
  return (
    <EducationPageChrome title={t('timetable')} description={t('timetableIntro')}>
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={12} key={card.path}>
            <Card size="small" title={card.title}>
              <Paragraph type="secondary">{card.desc}</Paragraph>
              <Button type="primary" onClick={() => navigate(card.path)}>
                {t('open')}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
